import React, { useEffect, useState } from 'react';
import insuranceData from './insurance-data-documents/InsuranceData-Business_v03a-Images-stock_v03-DocLinks.json';


type InsuranceCategory = {
  id: string;
  title: string;
  description: string;
  benefits: string[];
  example: string;
  imageUrls: {
    url: string;
    altText: string;
  }[];
  jsonDocument: string;
};

type Example = {
  title: string;
  description: string;
  imageUrl?: string;
};

const InsuranceLookup_v03: React.FC = () => {
  const categories: InsuranceCategory[] = insuranceData.businessServices;

  const [selectedId, setSelectedId] = useState<string>('');
  const [selectedCategory, setSelectedCategory] = useState<InsuranceCategory | null>(null);
  const [examples, setExamples] = useState<Example[]>([]);

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const id = event.target.value;
    setSelectedId(id);
    const category = categories.find((item) => item.id === id) || null;
    setSelectedCategory(category);
    setExamples([]);
  };

  useEffect(() => {
    const loadExamples = async () => {
      if (selectedCategory?.jsonDocument) {
        try {
            ///insiurance-data-documents/BUSINESS_BusinessInterruption_v01.json

          console.log("category ", selectedCategory.jsonDocument);

          const response = await fetch(`/insiurance-data-documents/${selectedCategory.jsonDocument}`);
          console.log("response", response);

          if (!response.ok) throw new Error('Failed to load examples');
          console.log("response status", response.ok);

          const data = await response.json();
        
          console.log("JSON DATA", data);


          if (Array.isArray(data.examples)) {
            setExamples(data.examples);
          } else if (Array.isArray(data)) {
            setExamples(data); // supports array-only files
          } else {
            console.error('Unexpected format in JSON');
          }
        } catch (err) {
          console.error(err);
          setExamples([]);
        }
      }
    };

    loadExamples();
  }, [selectedCategory]);

  return (
    <div style={{ maxWidth: '1200px', margin: '2rem auto', padding: '1rem' }}>
      <h2>Business Insurance Category Lookup</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="insuranceDropdown" style={{ marginRight: '1rem', fontWeight: 600 }}>
          Select a category:
        </label>
        <select
          id="insuranceDropdown"
          value={selectedId}
          onChange={handleSelect}
          style={{ padding: '0.5rem', width: '60%' }}
        >
          <option value="">-- Select a category --</option>
          {categories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>
      </div>

      {selectedCategory && (
        <div style={{ display: 'flex', gap: '2rem' }}>
          {/* Left Card */}
          <div style={{ flex: '1', border: '1px solid #ccc', borderRadius: '8px', padding: '1rem' }}>
            <h4>{selectedCategory.title}</h4>
            <p><strong>Description:</strong> {selectedCategory.description}</p>
            <h5>Benefits:</h5>
            <ul>
              {selectedCategory.benefits.map((benefit, idx) => (
                <li key={idx}>{benefit}</li>
              ))}
            </ul>
            <p><strong>Example:</strong> {selectedCategory.example}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              {selectedCategory.imageUrls.map((img, idx) => (
                <img
                  key={idx}
                  src={img.url}
                  alt={img.altText}
                  style={{ width: '120px', borderRadius: '4px' }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://via.placeholder.com/120?text=No+Image';
                  }}
                />
              ))}
            </div>
          </div>

          {/* Right List */}
          <div style={{ flex: '1.2', overflowY: 'auto', maxHeight: '600px' }}>
            <h5>Examples</h5>
            {examples.length === 0 ? (
              <p>No examples loaded.</p>
            ) : (
              <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                {examples.map((ex, idx) => (
                  <li
                    key={idx}
                    style={{
                      marginBottom: '1rem',
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <strong>{ex.title}</strong>
                    <p>{ex.description}</p>
                    {ex.imageUrl && (
                      <img
                        src={ex.imageUrl}
                        alt={ex.title}
                        style={{ maxWidth: '100%', borderRadius: '4px' }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300?text=No+Image';
                        }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InsuranceLookup_v03;
